define("powergen/routes/setup",
  [],
  function() {
    "use strict";
    var SetupRoute;

    SetupRoute = Ember.Route.extend({
      model: function() {
        return Ember.Object.create();
      },
      setupController: function(controller, model) {
        return controller.setProperties({
          'model': model,
          'keyboard': this.get('store').getById('keyboard', 'main')
        });
      }
    });


    return SetupRoute;
  });